export default {"src":"/_next/static/media/py.034cf59e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};